import { ViewChild, Component } from '@angular/core';
import { ModalController, NavController, NavParams, Tabs, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

import { ConsumerBusinessListPage } from '../consumer-business-list/consumer-business-list';
import { ConsumerPinsPage } from '../consumer-pins/consumer-pins';

import { ConsumerOfferListPage } from '../consumer-offer-list/consumer-offer-list';

import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';
import { ConsumerRewardListPage } from '../../pages/consumer-reward-list/consumer-reward-list';
import { ConsumerMessageTimelinePage } from '../../pages/consumer-message-timeline/consumer-message-timeline';
import { ConsumerProfileMainPage } from '../../pages/consumer-profile-main/consumer-profile-main';
import { ConsumerMessageDetailPage } from '../../pages/consumer-message-detail/consumer-message-detail';
import { ConsumerRedeemablesMainPage } from '../../pages/consumer-redeemables-main/consumer-redeemables-main';

import { ConsumerMoneyMainOrderListPage } from '../../pages/consumer-money-main-order-list/consumer-money-main-order-list';


import { Globals } from '../../providers/globals';
import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';

@Component({
  selector: 'page-consumer-main',
  templateUrl: 'consumer-main.html',
})
export class ConsumerMainPage {
  rootPage: any;

  tab1Root = ConsumerBusinessListPage;
  tab2Root = ConsumerOfferListPage;
  tab3Root = ConsumerMessageTimelinePage;
  tab4Root = ConsumerProfilePage;
  tab5Root = ConsumerMoneyMainOrderListPage;
  //tab5Root = ConsumerServiceListPage;
  
  constructor(
    public menuCtrl: MenuController,
    public modalCtrl: ModalController,
    public globals: Globals,
    public navCtrl: NavController, 
    public navParams: NavParams,
    private pushNotificationHandlerProvider: PushNotificationHandlerProvider,
    statusBar: StatusBar, 
    ) {  
      // this.rootPage = ConsumerBusinessListPage;

    console.log("constructor ConsumerMainPage!");
  }

  ionViewDidEnter() {
  }  

  openPage(pageName){
    switch (pageName) {
      // case "businesses":
      //   this.rootPage = ConsumerBusinessListPage
      //   break;     
      //   case "offers":
      //   this.rootPage = ConsumerOfferListPage;
      //   break; 
      // case "timeline":
      //   this.rootPage = ConsumerMessageTimelinePage;
      //   break;
      case "favorites":
        this.rootPage = ConsumerPinsPage;
        break;
      // case "redeemableList":
      //   this.rootPage = ConsumerRedeemablesMainPage;
      //   break; 
      case "profile":
        this.rootPage = ConsumerProfileMainPage;
        break;                  
    }

    this.menuCtrl.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/consumer-main/consumer-main.ts